import React, { FC, useState } from 'react';
import { Button, message } from 'antd';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { CopyIcon } from '~/img';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import cx from 'classnames';

interface CopyButtonProps {
  text: string;
  isIcon?: boolean;
  className?: string;
}

const CopyButton: FC<CopyButtonProps> = (props) => {
  const { text, isIcon, className } = props;
  const [copying, setCopying] = useState(false);

  const [t] = useTranslation();

  const handleCopy = () => {
    setCopying(true);
    message.success(t('textCopied'));
    setTimeout(() => {
      setCopying(false);
    }, 1000);
  };

  if (isIcon) {
    return (
      <CopyToClipboard text={text} onCopy={handleCopy}>
        <Button
          icon={<CopyIcon />}
          size="small"
          loading={copying}
          type="default"
          className={cx('button', className)}
        />
      </CopyToClipboard>
    );
  }
  return (
    <CopyToClipboard text={text} onCopy={handleCopy}>
      <Button icon={<CopyIcon />} size="middle" type="link" className="button">
        {t('copyToClipboard')}
      </Button>
    </CopyToClipboard>
  );
};

export default styled(CopyButton)`
  color: #a1a0ae;
  background-color: #e8e9ec;
`;
